module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cancel":"Cancel","browserList":"You need to use the latest version of one of the following:","data":"Personal data","permissions":"Permissions","microphone":"Mic setup","camera":"Camera setup","interview":"Interview","candidateAgreed":"Candidate agreed to a recorded interview","cameraOn":"Turn on your camera"}}')
  delete Component.options._Ctor
}
